﻿import * as eventTypes from '../../../map/utils/eventTypes';
import * as geomTypes from '../../../map/utils/geomTypes';
import * as layerTypes from '../../../map/utils/layerTypes';
import * as styleTypes from '../../../map/utils/style/styleTypes';
import Draw from 'ol/interaction/Draw';
import {
    Circle as CircleStyle,
    Fill,
    RegularShape,
    Stroke,
    Style,
    Text,
} from 'ol/style.js';
import { LineString, Point } from 'ol/geom.js';
import { getArea, getLength } from 'ol/sphere.js';
import { primaryAction } from 'ol/events/condition';
export default class MeasurementControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, toolbarContainer) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.toolbarContainer = toolbarContainer;
        this.measurePointId = 'measure-point-id-' + this.classId;
        this.measureLineId = 'measure-line-id-' + this.classId;
        this.measurePolyLineId = 'measure-polyline-id-' + this.classId;
        this.measureCircleId = 'measure-circle-id-' + this.classId;
        this.measurePolygonId = 'measure-polygon-id-' + this.classId;
        this.measurePolygonId = 'measure-polygon-id-' + this.classId;
        this.deleteMeasurementId = 'delete-measurement-id-' + this.classId;
        this.deleteAllMeasurementsId = 'delete-all-measurements-id-' + this.classId;
        this.uomId = 'uom-id-' + this.classId;
        this.labelSegmentLengthId = 'label-segment-length-id-' + this.classId;
        this.labelSegmentAngleId = 'label-segment-angle-id-' + this.classId;
        this.active = false;
        this.layerAdded = false;
        this.currentInteraction = null;
        this.currentDrawType = null;
        this.deleteEnabled = false;
        this.currentId = 1;
        this.keydownEvent = (evt) => {
            if (evt.keyCode == 27) {
                this._stopDraw();
            }
        };
        this._initStandardStyle();
        this._initStandardSelectStyle();
        this._initDrawStyle();
    }

    init() {
        if ($('.map-serach-config').length > 0) {
            $('.map-serach-config').addClass('map-search-joined');
        }

        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
        $event.register(eventTypes.USER_INTERACTION_STARTED, this._getUserInteractionStartedHandler(), this, this.classId);
        $event.register(eventTypes.MAP_POINTER_MOVE, this._getUserMapPointerMoveHandler(), this, this.classId);
        $event.register(eventTypes.MAP_POINTER_CLICK, this._getUserMapPointerClickHandler(), this, this.classId);
        $event.register(eventTypes.RIGHT_CLICK, this._getUserMapRightClickHandler(), this, this.classId);
    }

    _stopDraw() {
        if (this.currentInteraction != null) {
            this.currentInteraction.abortDrawing();
            data.originalEvent.preventDefault();
            this.currentInteractionSuspended = true;
            this._removeInteraction();

            if ($('.feature-toolbar-button.active').length > 0) {
                let item = $($('.feature-toolbar-button.active')[0]);
                item.removeClass('active');
                item.click();
            }
        }
    }

    _getUserMapPointerMoveHandler() {
        var handler = (eventName, data, sender) => {
            if (this.deleteEnabled) {
                if (data.originalEvent == null) {
                    return;
                }

                let pixel = this.mapControl.map.getEventPixel(data.originalEvent);

                if (pixel == null) {
                    return;
                }

                let options = {
                    layerFilter: (layer) => {
                        return layer.get("uid") == layerTypes.MEASUREMENTS;
                    }
                }

                var features = this.mapControl.map.getFeaturesAtPixel(pixel, options);

                if (features.length > 0) {
                    this.mapControl.map.getViewport().style.cursor = 'pointer';
                } else {
                    this.mapControl.map.getViewport().style.cursor = 'inherit';
                }
            }
        };

        return handler;
    }

    _getUserMapRightClickHandler() {
        var handler = (eventName, data, sender) => {
            this._stopDraw();
        };

        return handler;
    }

    _getUserMapPointerClickHandler() {
        var handler = (eventName, data, sender) => {

            if (this.deleteEnabled) {
                if (data.originalEvent == null) {
                    return;
                }

                let pixel = this.mapControl.map.getEventPixel(data.originalEvent);

                if (pixel == null) {
                    return;
                }

                let options = {
                    layerFilter: (layer) => {
                        return layer.get("uid") == layerTypes.MEASUREMENTS;
                    }
                }

                var features = this.mapControl.map.getFeaturesAtPixel(pixel, options);

                if (features.length > 0) {
                    this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource().removeFeature(features[0]);
                }
            }
        };

        return handler;
    }

    _initStandardStyle() {
        this.measureStyle = new Style({
            fill: new Fill({
                color: 'rgba(0, 183, 235, 1)',
            }),
            stroke: new Stroke({
                color: 'rgba(0, 183, 235, 1)',
                width: 3,
            }),
            image: new RegularShape({
                radius: 8,
                radius2: 1,
                points: 4,
                angle: 0,
                stroke: new Stroke({
                    color: 'rgba(0, 183, 235, 1)',
                }),
                fill: new Fill({
                    color: 'rgba(0, 183, 235, 1)',
                }),
            }),
        });

        this.segmentStyle = new Style({
            text: new Text({
                font: '16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 183, 235, 1)',
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                }),
                overflow: 'true',
                maxAngle: 360,
                placement: 'line',
                offsetY: -10,
            })
        });

        this.labelStyle = new Style({
            text: new Text({
                font: '16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 183, 235, 1)',
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: -10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                })
            })
        });
    }

    _initStandardSelectStyle() {
        this.selectedMeasureStyle = new Style({
            fill: new Fill({
                color: 'rgba(0, 255, 12, 0.3)',
            }),
            stroke: new Stroke({
                color: 'rgba(0, 255, 12, 1)',
                width: 3,
            }),
            image: new RegularShape({
                radius: 8,
                radius2: 1,
                points: 4,
                angle: 0,
                stroke: new Stroke({
                    color: 'rgba(0, 255, 12, 1)',
                }),
                fill: new Fill({
                    color: 'rgba(0, 255, 12, 0.3)',
                }),
            }),
        });

        this.selectedSegmentStyle = new Style({
            text: new Text({
                font: '16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 255, 12, 1)',
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                }),
                overflow: 'true',
                maxAngle: 360,
                placement: 'line',
                offsetY: -10,
            })
        });

        this.selectedLabelStyle = new Style({
            text: new Text({
                font: '16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 255, 12, 1)',
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: -10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                })
            })
        });
    }

    _initDrawStyle() {
        this.drawMeasureStyle = new Style({
            fill: new Fill({
                color: 'rgba(255, 0, 0, 1)',
            }),
            stroke: new Stroke({
                color: 'rgba(255, 0, 0, 1)',
                width: 3,
            }),
            image: new RegularShape({
                radius: 8,
                radius2: 1,
                points: 4,
                angle: 0,
                stroke: new Stroke({
                    color: 'rgba(255, 0, 0, 1)',
                }),
                fill: new Fill({
                    color: 'rgba(255, 0, 0, 1)',
                }),
            }),
        });

        this.drawLabelStyle = new Style({
            text: new Text({
                font: 'bold 16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 0, 0, 1)',
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: -10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                })
            })
        });
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.active) {
                this._removeInteraction();
                this._hideToolbar();
            } else {
                $event.notify(eventTypes.USER_INTERACTION_STARTED, {}, this, this.classId);
                this._showToolbar();
            }
        };
    }

    _getUserInteractionStartedHandler() {
        var handler = (eventName, data, sender) => {
            this._removeInteraction();
            this._hideToolbar();
        };

        return handler;
    }

    _hideToolbar() {
        this.active = false;
        this.toolbarContainer.innerHTML = '';
        this.mapControl.selectionHandler.isActive = true;
        document.removeEventListener('keydown', this.keydownEvent);
        $event.notify(eventTypes.DRAW_TOOLBAR_HIDDEN, {}, this, this.classId);
        $('#' + this.elementId).removeClass('selected');
    }

    _showToolbar() {
        $('#' + this.elementId).addClass('selected');
        if (!this.layerAdded) {
            this._addMeasurementLayer();
        }

        this.active = true;
        this.toolbarContainer.innerHTML = this._getToolbarTemplate();
        this.mapControl.map.getViewport().style.cursor = 'inherit';

        $('.feature-toolbar-extra-content').css('width', $('.header-options').width() + 'px');

        $('#' + this.labelSegmentLengthId).kendoSwitch({
            messages: {
                checked: '',
                unchecked: ''
            },
            checked: true
        });

        $('#' + this.labelSegmentAngleId).kendoSwitch({
            messages: {
                checked: '',
                unchecked: ''
            },
            checked: true
        });

        let uoms = this._getUom();

        $('#' + this.uomId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: uoms
        });

        $('#' + this.uomId).data('kendoComboBox').value(uoms[1].id);

        $('#' + this.measurePointId).on('click', () => {
            this._measurePoint();
        });

        $('#' + this.measureLineId).on('click', () => {
            this._measureLine();
        });

        $('#' + this.measurePolyLineId).on('click', () => {
            this._measurePolyLine();
        });

        $('#' + this.measureCircleId).on('click', () => {
            this._measureCircle();
        });

        $('#' + this.measurePolygonId).on('click', () => {
            this._measurePolygon();
        });

        $('#' + this.deleteMeasurementId).on('click', () => {
            this._deleteMeasurement();
        });

        $('#' + this.deleteAllMeasurementsId).on('click', () => {
            this._deleteAllMeasurements();
        });

        document.addEventListener('keydown', this.keydownEvent);
        $event.notify(eventTypes.DRAW_TOOLBAR_VISIBLE, {}, this, this.classId);
    }

    _addMeasurementLayer() {
        this.layerAdded = true;
        this.mapControl.addTemporaryVectorLayer({
            name: layerTypes.MEASUREMENTS,
            geometryType: geomTypes.GEOM_ALL,
            srid: this.mapControl.generalSettingsHandler.settings.ProjCode,
            geomField: 'geom',
            idField: 'id',
            visible: true,
            displayName: this.resourcesHandler.get('MeasureResults'),
            ignoreStyle: true,
            addToLegend: true,
            parentId: layerTypes.INTERACTION_TOOLS,
            parentDisplayName: this.resourcesHandler.get('UserInteractionResults'),
            showLegend: false,
            declutter: false,
            selectable: true
        }).then(() => {
            let layer = this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0];
            layer.setStyle((feature) => {
                return this._styleFunction(feature, feature.get('drawType'));
            });
        });
    }

    _measurePoint() {
        if ($('#' + this.measurePointId).hasClass('active')) {
            $('#' + this.measurePointId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.measurePointId).addClass('active');
            this._startMeasurePoint();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            $event.notify(eventTypes.DRAW_TOOLBAR_VISIBLE, {}, this, this.classId);
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _removeInteraction() {
        if (this.currentInteraction != null) {
            this.mapControl.map.removeInteraction(this.currentInteraction);
            this.currentInteraction = null;
        }

        $event.notify(eventTypes.STOP_SNAP, {}, this, this.mapControl.classId);

        this.deleteEnabled = false;
    }

    _styleFunction(feature, drawType) {
        let styles = [];

        if (feature.get('xstate') == 5) {
            return styles;
        }

        let geometry = feature.getGeometry();
        let type = geometry.getType();
        let point, label, line, circleLine;
        let isSelected = feature.get('xstate') == styleTypes.SELECT_STYLE_TYPE || feature.get('xstate') == styleTypes.HOVER_STYLE_TYPE;
        if (!drawType || drawType === type || type === 'Point' || drawType == 'Line' || drawType == 'PolyLine') {
            let allStyle = isSelected ? this.selectedMeasureStyle.clone() : this.measureStyle.clone();
            if (drawType == 'Circle' || drawType == 'Polygon') {
                allStyle.getFill().setColor('rgba(0, 0, 0, 0)');
            }

            if (drawType == 'Point') {
                styles.push(new Style({
                    image: new RegularShape({
                        radius: 11,
                        radius2: 3,
                        points: 4,
                        angle: 0,
                        stroke: new Stroke({
                            color: 'rgba(255, 255, 255, 1)',
                        }),
                        fill: new Fill({
                            color: 'rgba(255, 255, 255, 1)',
                        }),
                    })
                }));
            } else {
                styles.push(new Style({
                    stroke: new Stroke({
                        color: 'rgba(255, 255, 255, 1)',
                        width: 5,
                    })
                }));
            }

            styles.push(allStyle);

            if (type === 'Polygon') {
                point = geometry.getInteriorPoint();
                label = this._formatArea(feature, geometry);
                line = new LineString(geometry.getCoordinates()[0]);
            } else if (type === 'LineString' && drawType == 'PolyLine') {
                point = new Point(geometry.getLastCoordinate());

                if (feature.get('showLength') == true) {
                    label = this._formatLength(feature, getLength(geometry));
                }

                line = geometry;
            } else if (type === 'LineString' && drawType == 'Line') {
                if (feature.get('showLength') == true) {
                    label = this._formatLength(feature, getLength(geometry));
                }

                line = geometry;
            } else if (drawType == 'Circle' && type != 'Point') {
                point = new Point(geometry.getCenter());
                label = this._formatCircleArea(feature, geometry);

                let secondPoint = geometry.getCenter();
                secondPoint[0] += geometry.getRadius();
                circleLine = new LineString([geometry.getCenter(), secondPoint]);
            } else if (drawType == 'Point') {
                point = new Point(geometry.getCoordinates());
                label = this._formatCoordinates(feature, geometry);
            }
        }

        let segments = true;
        let segmentCount = 0;
        let perimeter, perimeterLabel;

        if (type == 'Polygon') {
            let points = feature.getGeometry().getCoordinates()[0];
            perimeter = 0;

            for (let i = 1; i < points.length; i++) {
                let segment = new LineString([points[i - 1], points[i]]);
                perimeter += getLength(segment);

                perimeterLabel = isSelected ? this.selectedLabelStyle.clone() : this.labelStyle.clone();
                perimeterLabel.setGeometry(geometry.getInteriorPoint());
                perimeterLabel.getText().setText(this._formatLength(feature, perimeter));
                perimeterLabel.getText().setOffsetY(10);
            }
        }

        if (segments && line) {
            line.forEachSegment((a, b) => {
                segmentCount++;
                let segment = new LineString([a, b]);

                if (feature.get('showLength') == true) {
                    let label = this._formatLength(feature, getLength(segment));
                    let segmentDistance = isSelected ? this.selectedSegmentStyle.clone() : this.segmentStyle.clone();
                    segmentDistance.setGeometry(segment);
                    segmentDistance.getText().setText(label);

                    styles.push(segmentDistance);
                }

                if (feature.get('showAngle') == true) {
                    let angle = this._formatAngle(feature, segment);
                    let segmentAngle = isSelected ? this.selectedSegmentStyle.clone() : this.segmentStyle.clone();
                    segmentAngle.setGeometry(segment);
                    segmentAngle.getText().setText(angle);
                    segmentAngle.getText().setOffsetY(10);

                    styles.push(segmentAngle);
                }
            });
        }

        if (circleLine) {
            let circleLineHalo = new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 5,
                })
            });

            circleLineHalo.setGeometry(circleLine);
            styles.push(circleLineHalo);

            let circleLineStyle = isSelected ? this.selectedMeasureStyle.clone() : this.measureStyle.clone();
            circleLineStyle.setGeometry(circleLine);
            styles.push(circleLineStyle);

            let circleCenter = geometry.getCenter();
            let centerLabel = this._formatCoordinates(feature, new Point(circleCenter));

            let centerLabelStyle = isSelected ? this.selectedLabelStyle.clone() : this.labelStyle.clone();
            centerLabelStyle.setGeometry(new Point(circleCenter));
            centerLabelStyle.getText().setText(centerLabel);
            centerLabelStyle.getText().setOffsetY(45);
            styles.push(centerLabelStyle);
        }

        if (label && drawType != 'Line' && !(drawType == 'PolyLine' && segmentCount == 1)) {
            let clone = isSelected ? this.selectedLabelStyle.clone() : this.labelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(label);
            styles.push(clone);
        }

        if (perimeterLabel) {
            styles.push(perimeterLabel);
        }

        return styles;
    }

    _drawStyleFunction(feature, drawType) {
        let styles = [];
        let geometry = feature.getGeometry();
        let type = geometry.getType();
        let point, label, line, circleLine, pointLabel;
        if (!drawType || drawType === type || type === 'Point') {
            let allStyle = this.drawMeasureStyle.clone();
            if (drawType == 'Circle' || drawType == 'Polygon') {
                allStyle.getFill().setColor('rgba(0, 0, 0, 0)');
            }

            if (type != 'Point') {
                styles.push(new Style({
                    stroke: new Stroke({
                        color: 'rgba(255, 255, 255, 1)',
                        width: 5,
                    })
                }));

                styles.push(allStyle);
            }

            if (type === 'Polygon') {
                point = geometry.getInteriorPoint();
                label = this._formatArea(feature, geometry);
                if (geometry.getCoordinates()[0].length > 2) {
                    line = new LineString([geometry.getCoordinates()[0][geometry.getCoordinates()[0].length - 3], geometry.getCoordinates()[0][geometry.getCoordinates()[0].length - 2]]);
                }
            } else if (type === 'LineString') {
                point = new Point(geometry.getLastCoordinate());
                label = this._formatLength(feature, getLength(geometry));
                pointLabel = this._formatCoordinates(feature, point);
                line = geometry;
            } else if (drawType == 'Circle' && type != 'Point') {
                point = new Point(geometry.getCenter());
                label = this._formatCircleArea(feature, geometry);

                let secondPoint = geometry.getCenter();
                secondPoint[0] += geometry.getRadius();
                circleLine = new LineString([geometry.getCenter(), secondPoint]);
            } else if (drawType == 'Point' || (type == 'Point' && drawType != 'Point')) {
                point = new Point(geometry.getCoordinates());
                label = this._formatCoordinates(feature, geometry);
            }
        }

        let lastSegmentAngle;
        let perimeterLabel;
        let perimeter;
        let cursorPoint;

        if (line) {
            line.forEachSegment((a, b) => {
                let segment = new LineString([a, b]);
                let angle = this._formatAngle(feature, segment);
                lastSegmentAngle = this.drawLabelStyle.clone();
                cursorPoint = new Point(segment.getLastCoordinate());
                lastSegmentAngle.setGeometry(cursorPoint);
                lastSegmentAngle.getText().setText(angle);

                if (type == 'Polygon') {
                    lastSegmentAngle.getText().setOffsetY(27);
                } else {
                    lastSegmentAngle.getText().setOffsetY(40);
                }
            });
        }

        if (type == 'Polygon') {
            let points = feature.getGeometry().getCoordinates()[0];
            perimeter = 0;

            for (let i = 1; i < points.length; i++) {
                let segment = new LineString([points[i - 1], points[i]]);
                perimeter += getLength(segment);

                perimeterLabel = this.drawLabelStyle.clone();
                perimeterLabel.setGeometry(geometry.getInteriorPoint());
                perimeterLabel.getText().setText(this._formatLength(feature, perimeter));
                perimeterLabel.getText().setOffsetY(10);
            }
        }

        if (label) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(label);

            if (pointLabel) {
                clone.getText().setOffsetY(27);
            }

            styles.push(clone);
        }

        if (pointLabel) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(pointLabel);
            
            styles.push(clone);
        }

        if (lastSegmentAngle) {
            styles.push(lastSegmentAngle);
        }

        if (perimeterLabel) {
            styles.push(perimeterLabel);
        }

        return styles;
    }

    _formatAngle(feature, geometry) {
        return Math.round(this._getRotation(geometry) * 1000) / 1000 + ' °';
    }

    _getRotation(geometry) {
        let coords = geometry.getCoordinates();

        let first = coords[0];
        let last = coords[1];
        let rotation = -Math.atan2((last[1] - first[1]), (last[0] - first[0]));
        rotation = rotation * (180 / Math.PI);

        if (rotation < 0) {
            rotation = 360 + rotation;
        }

        rotation += 90;

        if (rotation > 360) {
            rotation -= 360;
        }

        return rotation;
    }

    _formatCoordinates(feature, geometry) {
        let coordinates = geometry.getCoordinates();
        return Math.round(coordinates[0] * 1000) / 1000 + ' \n ' + Math.round(coordinates[1] * 1000) / 1000;
    }

    _formatLength(feature, length) {
        let output;

        let uom;

        if (feature.get('labelUnits') != null) {
            uom = feature.get('labelUnits');
        } else {
            uom = $('#' + this.uomId).data('kendoComboBox').value();
        }

        switch (uom) {
            case 'CM': output = Math.round(length * 10000) / 100 + ' cm';
                break;
            case 'M': output = Math.round(length * 100) / 100 + ' m';
                break;
            case 'KM': output = Math.round((length / 1000) * 100) / 100 + ' km';
                break;
        }

        return output;
    }

    _formatArea(feature, polygon) {
        let area = polygon.getArea();
        let output;

        let uom;

        if (feature.get('labelUnits') != null) {
            uom = feature.get('labelUnits');
        } else {
            uom = $('#' + this.uomId).data('kendoComboBox').value();
        }

        switch (uom) {
            case 'CM': output = Math.round(area * 1000000) / 100 + ' cm\xB2';
                break;
            case 'M': output = Math.round(area * 100) / 100 + ' m\xB2';
                break;
            case 'KM': output = Math.round((area / 1000000) * 100) / 100 + ' km\xB2';
                break;
        }

        return output;
    }

    _formatCircleArea(feature, circle) {
        let radius = circle.getRadius();
        let area = Math.PI * Math.pow(radius, 2);
        let output;
        let uom;

        if (feature.get('labelUnits') != null) {
            uom = feature.get('labelUnits');
        } else {
            uom = $('#' + this.uomId).data('kendoComboBox').value();
        }

        switch (uom) {
            case 'CM': output = Math.round(area * 1000000) / 100 + ' cm\xB2';
                break;
            case 'M': output = Math.round(area * 100) / 100 + ' m\xB2';
                break;
            case 'KM': output = Math.round((area / 1000000) * 100) / 100 + ' km\xB2';
                break;
        }

        return output;
    }

    _startMeasurePoint() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource(),
            type: 'Point',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Point');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource().removeFeature(evt.feature);
            } else {
                evt.feature.set('showLength', $('#' + this.labelSegmentLengthId).data('kendoSwitch').check());
                evt.feature.set('showAngle', $('#' + this.labelSegmentAngleId).data('kendoSwitch').check());
                evt.feature.set('labelUnits', $('#' + this.uomId).data('kendoComboBox').value());
                evt.feature.set('drawType', 'Point');
                evt.feature.layerId = layerTypes.MEASUREMENTS;
                evt.feature.set('id', this.currentId);
                this.currentId++;
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Point' }, this, this.mapControl.classId);
    }

    _measureLine() {
        if ($('#' + this.measureLineId).hasClass('active')) {
            $('#' + this.measureLineId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.measureLineId).addClass('active');
            this._startMeasureLine();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _startMeasureLine() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource(),
            type: 'LineString',
            maxPoints: 2,
            style: (feature) => {
                return this._drawStyleFunction(feature, 'LineString');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource().removeFeature(evt.feature);
            } else {
                evt.feature.set('showLength', $('#' + this.labelSegmentLengthId).data('kendoSwitch').check());
                evt.feature.set('showAngle', $('#' + this.labelSegmentAngleId).data('kendoSwitch').check());
                evt.feature.set('labelUnits', $('#' + this.uomId).data('kendoComboBox').value());
                evt.feature.set('drawType', 'Line');
                evt.feature.layerId = layerTypes.MEASUREMENTS;
                evt.feature.set('id', this.currentId);
                this.currentId++;
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'LineString' }, this, this.mapControl.classId);
    }

    _measurePolyLine() {
        if ($('#' + this.measurePolyLineId).hasClass('active')) {
            $('#' + this.measurePolyLineId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.measurePolyLineId).addClass('active');
            this._startMeasurePolyLine();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _startMeasurePolyLine() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource(),
            type: 'LineString',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'LineString');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource().removeFeature(evt.feature);
            } else {
                evt.feature.set('showLength', $('#' + this.labelSegmentLengthId).data('kendoSwitch').check());
                evt.feature.set('showAngle', $('#' + this.labelSegmentAngleId).data('kendoSwitch').check());
                evt.feature.set('labelUnits', $('#' + this.uomId).data('kendoComboBox').value());
                evt.feature.set('drawType', 'PolyLine');
                evt.feature.layerId = layerTypes.MEASUREMENTS;
                evt.feature.set('id', this.currentId);
                this.currentId++;
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'LineString' }, this, this.mapControl.classId);
    }

    _measureCircle() {
        if ($('#' + this.measureCircleId).hasClass('active')) {
            $('#' + this.measureCircleId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.measureCircleId).addClass('active');
            this._startMeasureCircle();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _startMeasureCircle() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource(),
            type: 'Circle',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Circle');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource().removeFeature(evt.feature);
            } else {
                evt.feature.set('showLength', $('#' + this.labelSegmentLengthId).data('kendoSwitch').check());
                evt.feature.set('showAngle', $('#' + this.labelSegmentAngleId).data('kendoSwitch').check());
                evt.feature.set('labelUnits', $('#' + this.uomId).data('kendoComboBox').value());
                evt.feature.set('drawType', 'Circle');
                evt.feature.layerId = layerTypes.MEASUREMENTS;
                evt.feature.set('id', this.currentId);
                this.currentId++;
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Circle' }, this, this.mapControl.classId);
    }

    _measurePolygon() {
        if ($('#' + this.measurePolygonId).hasClass('active')) {
            $('#' + this.measurePolygonId).removeClass('active');
            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this.mapControl.selectionHandler.isActive = true;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.measurePolygonId).addClass('active');
            this._startMeasurePolygon();
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this.mapControl.selectionHandler.isActive = false;
        }
    }

    _startMeasurePolygon() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource(),
            type: 'Polygon',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Polygon');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource().removeFeature(evt.feature);
            } else {
                evt.feature.set('showLength', $('#' + this.labelSegmentLengthId).data('kendoSwitch').check());
                evt.feature.set('showAngle', $('#' + this.labelSegmentAngleId).data('kendoSwitch').check());
                evt.feature.set('labelUnits', $('#' + this.uomId).data('kendoComboBox').value());
                evt.feature.set('drawType', 'Polygon');
                evt.feature.layerId = layerTypes.MEASUREMENTS;
                evt.feature.set('id', this.currentId);
                this.currentId++;
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Polygon' }, this, this.mapControl.classId);
    }

    _deleteMeasurement() {
        if ($('#' + this.deleteMeasurementId).hasClass('active')) {
            $('#' + this.deleteMeasurementId).removeClass('active');
            this.deleteEnabled = false;
        } else {
            $('.feature-toolbar-button').removeClass('active');
            $('#' + this.deleteMeasurementId).addClass('active');
            this.mapControl.map.getViewport().style.cursor = 'inherit';
            this._removeInteraction();
            this.deleteEnabled = true;
        }
    }

    _deleteAllMeasurements() {
        this.mapControl.layerHandler.getLayerById(layerTypes.MEASUREMENTS)[0].getSource().clear();
    }

    _getUom() {
        return [
            {
                id: 'CM',
                name: this.resourcesHandler.get('CM')
            }, {
                id: 'M',
                name: this.resourcesHandler.get('M')
            }, {
                id: 'KM',
                name: this.resourcesHandler.get('KM')
            }
        ];
    }

    _getToolbarTemplate() {
        return `<div class="feature-toolbar-content">
                    <div title="` + this.resourcesHandler.get('MeasurePoint') + `" class="feature-toolbar-button fal fa-crosshairs" id="` + this.measurePointId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('MeasureLine') + `" class="feature-toolbar-button fal fa-slash" id="` + this.measureLineId + `" style="rotate: 90deg; font-size: 0.7rem; font-weight: 600;">
                    </div>
                    <div title="` + this.resourcesHandler.get('MeasurePolyLine') + `" class="feature-toolbar-button ni ni-graph" id="` + this.measurePolyLineId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('MeasureCircle') + `" class="feature-toolbar-button fal fa-draw-circle" id="` + this.measureCircleId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('MeasurePolygon') + `" class="feature-toolbar-button fal fa-draw-polygon" id="` + this.measurePolygonId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('RemoveMeasurement') + `" class="feature-toolbar-button fal fa-comment-times" id="` + this.deleteMeasurementId + `">
                    </div>
                    <div title="` + this.resourcesHandler.get('RemoveAllMeasurements') + `" class="feature-toolbar-button fal fa-trash-alt" id="` + this.deleteAllMeasurementsId + `">
                    </div>
                </div>
                <div class="feature-toolbar-extra-content">
                    <div class="col-12 mb-3 align-content-start pt-3 custom-map-switch">
                        <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                            <label class="form-label ml-3">` + this.resourcesHandler.get('LabelSegmentLength') + `</label>
                            <div id="` + this.labelSegmentLengthId + `"></div>
                        </div>
                    </div>
                    <div class="col-12 mb-3 align-content-start pt-0 custom-map-switch">
                        <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                            <label class="form-label ml-3">` + this.resourcesHandler.get('LabelSegmentAngle') + `</label>
                            <div id="` + this.labelSegmentAngleId + `"></div>
                        </div>
                    </div>
                    <div class="col-12 mb-3" style="margin-top: -4px;">
                        <div class="form-group d-flex">
                            <div class="col-4 align-content-center pl-0">
                                <label>` + this.resourcesHandler.get('UOM') + `:</label>
                            </div>
                            <div class="col-8">
                                <input class="form-control" id="` + this.uomId + `">
                            </div>
                        </div>
                    </div>
                </div>`;
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}